import React, { useEffect } from 'react';

import useGlobal from '../../../store';
import Table from '../../../facturotopia/table/Table';
import TimbradoMasivoTicketsRenderStatus from './components/TimbradoMasivoTicketsRenderStatus';

const mapState = (store) => {
  return store.modulo.timbrado_masivo.tickets;
};

const mapActions = (actions) => {
  return { ...actions.modulo.timbrado_masivo.tickets };
};

const TimbradoMasivoTicketList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      actions.paginate({
        page: 1,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    const { filters } = state;

    actions.paginate({
      ...filters,
      ...meta,
    });
  };

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const getPaginationConfig = () => {
    const { pagination } = state;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const setSelectedRows = (event) => {
    actions.setSelectedRows(event);

    !!props.onRowSelectionChange && props.onRowSelectionChange(event);
  };

  const getRowSelectionConfig = () => {
    const { selectedRowKeys = [] } = props;

    return {
      type: 'checkbox',
      selectedRowKeys,
      onChange: setSelectedRows,
      getCheckboxProps: (record) => ({
        name: record.name,
      }),
    };
  };

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      selectable={true}
      pagination={getPaginationConfig()}
      onRow={onRowRender}
      rowSelection={getRowSelectionConfig()}
    ></Table>
  );
};

const onRowRender = (item) => {
  return {
    className: item.highlight ? 'row-highlighted' : '',
  };
};

const columns = [
  {
    key: 'fecha_servicio',
    title: 'Fecha Servicio',
    dataIndex: 'fecha_servicio',
    className: 'cell-medium',
  },
  {
    key: 'created_at',
    title: 'Fecha',
    dataIndex: 'created_at',
    className: 'cell-medium',
  },
  {
    key: 'emisor_rfc',
    title: 'Emisor',
    dataIndex: 'emisor_rfc',
  },
  {
    key: 'receptor_rfc',
    title: 'Receptor',
    dataIndex: 'receptor_rfc',
  },
  {
    key: 'tipo_comprobante',
    title: 'Comprobante',
    dataIndex: 'tipo_comprobante',
    className: 'cell-small',
  },
  {
    key: 'receptor_razon_social',
    title: 'Receptor nombre',
    dataIndex: 'receptor_razon_social',
    className: 'cell-xlarge',
  },
  {
    key: 'forma_de_pago',
    title: 'Forma Pago',
    dataIndex: 'forma_de_pago',
    align: 'center',
  },
  {
    key: 'metodo_de_pago',
    title: 'Método Pago',
    dataIndex: 'metodo_de_pago',
    align: 'center',
  },
  {
    key: 'subtotal',
    title: 'Subtotal',
    dataIndex: 'subtotal',
    align: 'right',
  },
  {
    key: 'descuento',
    title: 'Descuento',
    dataIndex: 'descuento',
    align: 'right',
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    align: 'right',
  },
  {
    key: 'cfdi_uuid',
    title: 'Cfdi Uuid',
    dataIndex: 'cfdi_uuid',
    align: 'center',
    className: 'cell-xxlarge',
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (item) => <TimbradoMasivoTicketsRenderStatus item={item} />,
  },
];

export default TimbradoMasivoTicketList;
